import * as types from './types'
import http from '../../utils/http'
// import store from '../index'
import Vue from 'vue'

const vue = new Vue()

// 处理最后一级数组为null
function processTree (data) {
  for (let i = 0; i < data.length; i++) {
    if (data[i].children.length < 1) {
      // children长度小于1, 将children置为null
      data[i].children = null
    } else {
      // 否则继续进入循环
      processTree(data[i].children)
    }
  }
  // 最后处理完的数据
  return data
}

const state = {

  /*
  * 菜单编辑
  * */
  // 可编辑菜单列表
  menuOfTree: [],
  /*
  * 学校
  * */
  menuOfTreeSchool: [],
  treeListSchool: [],
  saasMenuEditMark: 0,
  /*
  * 账号管理
  * */
  accountManageList: {},
  accountSelect: [], // 下拉框
  accountManageMark: 0,
  /*
  * 组织机构
  * */
  organizeList: {},
  organizeMark: 0,
  /*
   * 角色管理
   * */
  UserManageList: {},
  UserManageMark: 0,
  UserManageTree: []

}

const actions = {
  /*
  * 角色管理
  * */
  // 获取列表
  [types.GETROLEPAGE] (context, params) {
    http.fetch('/api/role/page', params).then(data => {
      context.commit(types.GETROLEPAGE, data)
    })
  },
  // 获取角色树形图数据
  [types.GETMENUROLETREE] (context, params) {
    http.fetch('/api/menu/getMenuRoleTree', params).then(data => {
      context.commit(types.GETMENUROLETREE, data)
    })
  },
  // 新增
  [types.GETROLEADD] (context, params) {
    http.fetch('/api/role/add', params).then(data => {
      context.commit(types.GETROLEADD, data)
    })
  },
  // 编辑
  [types.GETROLEUPDATE] (context, params) {
    http.fetch('/api/role/update', params).then(data => {
      context.commit(types.GETROLEUPDATE, data)
    })
  },
  // 启用/禁用
  [types.GETROLEUPDATESTATUS] (context, params) {
    http.fetch('/api/role/updateStatus', params).then(data => {
      context.commit(types.GETROLEUPDATESTATUS, data)
    })
  },
  /*
  * 账号管理
  * */
  // 列表
  [types.SAASGETUSERPAGES] (context, params) {
    http.fetch('/api/powerUser/getUserPage', params).then(data => {
      context.commit(types.SAASGETUSERPAGES, data)
    })
  },
  // 新增
  [types.SAASUSERADD] (context, params) {
    http.fetch('/api/powerUser/add', params).then(data => {
      context.commit(types.SAASUSERADD, data)
    })
  },
  // 编辑
  [types.SAASUSERUPDATE] (context, params) {
    http.fetch('/api/powerUser/update', params).then(data => {
      context.commit(types.SAASUSERUPDATE, data)
    })
  },
  // 删除
  [types.SAASUSERDEL] (context, params) {
    http.fetch('/api/powerUser/del', params).then(data => {
      context.commit(types.SAASUSERDEL, data)
    })
  },
  // 禁用 / 启用
  [types.SAASUSERDISABLED] (context, params) {
    http.fetch('/api/powerUser/update', params).then(data => {
      context.commit(types.SAASUSERDISABLED, data)
    })
  },
  // 下拉框 - 配置角色
  [types.SAASGETUSERROLE] (context, params) {
    http.fetch('/api/powerUser/getUserRole', params).then(data => {
      context.commit(types.SAASGETUSERROLE, data)
    })
  },
  // 重置密码
  [types.SAASUSERRESETPWD] (context, params) {
    http.fetch('/api/powerUser/resetPwd', params).then(data => {
      context.commit(types.SAASUSERRESETPWD, data)
    })
  },
  /*
  * 菜单编辑
  * */
  // 获取可编辑菜单 ==============
  [types.GETMENUOFTERR] (context, params) {
    http.fetch('/api/menu/getMMenuTree', params).then(data => {
      data.mark = params.mark
      context.commit(types.GETMENUOFTERR, data)
    })
  },

  // 获取上一级菜单
  [types.GETTREE] (context, params) {
    http.fetch('/api/menu/getTree', params).then(data => {
      data.mark = params.mark
      context.commit(types.GETTREE, data)
    })
  },
  // 新增菜单
  [types.ADDMENU] (context, params) {
    http.fetch('/api/menu/add', params).then(data => {
      context.commit(types.ADDMENU, data)
    })
  },
  // 编辑
  [types.UPDATEMENU] (context, params) {
    http.fetch('/api/menu/update', params).then(data => {
      context.commit(types.UPDATEMENU, data)
    })
  },
  // 删除
  [types.DELETEMENU] (context, params) {
    http.fetch('/api/menu/delete', params).then(data => {
      context.commit(types.DELETEMENU, data)
    })
  }
}

const mutations = {
  /*
  * 角色管理
  * */
  // 获取列表
  [types.GETROLEPAGE] (state, data) {
    console.log('data', data)
    state.UserManageList = data
  },
  // 获取角色树形图数据
  [types.GETMENUROLETREE] (state, data) {
    console.log(data, '获取角色树形图数据')
    state.UserManageTree = data.obj.menuTree
  },
  // 新增
  [types.GETROLEADD] (state, data) {
    console.log(data)
    if (data.code === 200) {
      state.UserManageMark = 1
      vue.$message({
        showClose: true,
        message: '新增成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 编辑
  [types.GETROLEUPDATE] (state, data) {
    console.log(data)
    if (data.code === 200) {
      state.UserManageMark = 1
      vue.$message({
        showClose: true,
        message: '编辑成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 启用/禁用
  [types.GETROLEUPDATESTATUS] (state, data) {
    console.log(data)
    if (data.code === 200) {
      state.UserManageMark = 1
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  /*
  * 账号管理
  * */
  // 列表
  [types.SAASGETUSERPAGES] (state, data) {
    state.accountManageList = data
  },
  // 新增
  [types.SAASUSERADD] (state, data) {
    if (data.code === 200) {
      state.accountManageMark = 1
      vue.$message({
        showClose: true,
        message: '添加成功',
        type: 'success'
      })
    }
  },
  // 编辑
  [types.SAASUSERUPDATE] (state, data) {
    if (data.code === 200) {
      state.accountManageMark = 1
      vue.$message({
        showClose: true,
        message: '编辑成功',
        type: 'success'
      })
    }
  },
  // 删除
  [types.SAASUSERDEL] (state, data) {
    if (data.code === 200) {
      state.accountManageMark = 1
      vue.$message({
        showClose: true,
        message: '删除成功',
        type: 'success'
      })
    }
  },
  // 禁用 / 启用
  [types.SAASUSERDISABLED] (state, data) {
    if (data.code === 200) {
      state.accountManageMark = 1
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 重置密码
  [types.SAASUSERRESETPWD] (state, data) {
    if (data.code === 200) {
      state.accountManageMark = 1
      vue.$message({
        showClose: true,
        message: '重置成功',
        type: 'success'
      })
    }
  },
  [types.SAASGETUSERROLE] (state, data) {
    state.accountSelect = data.obj
  },
  /*
  * 菜单编辑
  * */
  // 获取可编辑菜单
  [types.GETMENUOFTERR] (state, data) {
    if (data.mark === 0) {
      state.menuOfTree = data.obj
    } else if (data.mark === 1) {
      state.menuOfTreeSchool = data.obj
    }
    console.log(state.menuOfTreeSchool)
  },

  // 获取上一级菜单
  [types.GETTREE] (state, data) {
    state.treeListSchool = processTree(data.obj)
    // }
    console.log(data, '获取上一级菜单')
  },
  // 新增菜单
  [types.ADDMENU] (state, data) {
    if (data.code === 200) {
      state.saasMenuEditMark = 1
      vue.$message({
        showClose: true,
        message: '添加成功',
        type: 'success'
      })
    }
  },
  // 编辑
  [types.UPDATEMENU] (state, data) {
    if (data.code === 200) {
      state.saasMenuEditMark = 1
      vue.$message({
        showClose: true,
        message: '修改成功',
        type: 'success'
      })
    }
  },
  // 删除
  [types.DELETEMENU] (state, data) {
    if (data.code === 200) {
      state.saasMenuEditMark = 1
      vue.$message({
        showClose: true,
        message: '移除成功',
        type: 'success'
      })
    }
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/saasManage/index.js